import { render, staticRenderFns } from "./FileAttachmentManager.vue?vue&type=template&id=666ba2ad&scoped=true&"
import script from "./FileAttachmentManager.vue?vue&type=script&lang=js&"
export * from "./FileAttachmentManager.vue?vue&type=script&lang=js&"
import style0 from "./FileAttachmentManager.vue?vue&type=style&index=0&id=666ba2ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666ba2ad",
  null
  
)

export default component.exports